export class FileUpload {
    cedula: String;
    codigoPrueba: String;
    codigo: any;
    extension: String;
}
